import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OtSessionService {

  private static readonly REGISTRATION_KEY = 'registration';

  constructor() { }

  public setRegistration(registration: any): void {
    if (registration) {
      registration = JSON.stringify(registration);
    }
    sessionStorage.setItem(OtSessionService.REGISTRATION_KEY, registration);
  }

  public getRegistration(): any {
    const registrationString = sessionStorage.getItem(OtSessionService.REGISTRATION_KEY);
    if (! registrationString) {
      return null;
    }
    return JSON.parse(registrationString);
  }
}
